<template>
  <div class="addOption">
    <div :class="{ tootip: numberActiveOptions === 3 }" @click="showAddOption">
      <div v-if="!openAddOption" class="addOption__true">
        <img src="@/assets/icons/Add.svg" alt="Add" />
        <span class="addOption__true-title">{{ $t('addOption') }}</span>
        <span v-if="numberActiveOptions === 3" class="tooltiptext">
          {{ $t('addNewOption') }}
        </span>
      </div>
      <div v-else class="addOption__false">
        <span class="addOption__false-title">{{ $t('doNotSaveOption') }}</span>
      </div>
    </div>
    <FormKit
      v-if="conditionShowAddOption()"
      id="option-form"
      v-model="formDataOption"
      type="form"
      name="newOption"
      :actions="false"
      @submit="submitForm"
    >
      <div class="addOption__dropdown">
        <Checkbox
          name="enabled"
          :value="formDataOption.enabled"
          :title="$t('active')"
          @change="formDataOption.enabled = !formDataOption.enabled"
        />
        <p class="title-options">{{ $t('position') }}</p>
        <Dropdown
          :class="{
            'dropdown-positions': true,
            'dropdown-positions-error':
              formDataOption.position === null && !error
          }"
          :selected-option="selectedPositions.selectedOption"
          :options="selectedPositions.options"
          @select-option="(option) => selectPositions(option)"
        />
        <div
          v-if="formDataOption.position === null && !error"
          class="error-message"
        >
          {{ $t('validation.required') }}
        </div>
        <div v-if="error" class="error-message">{{ error }}</div>
      </div>
      <div class="addOption__infoTemplates">
        <Input
          type="text"
          name="title"
          :value="formDataOption.title"
          :validation="'required'"
          :validation-messages="{
            required: $t('validation.required')
          }"
        />
        <div class="addOption__infoTemplates-translations">
          <FormKit type="group" name="translations">
            <div
              v-for="(translation, index) in translations"
              :key="index"
              class="container"
            >
              <span>{{ translation.label }}</span>
              <Input
                type="text"
                :name="translation.value"
                :value="formDataOption.translations[translation.value]"
                :validation="'required'"
                :validation-messages="{
                  required: $t('validation.required')
                }"
              />
            </div>
          </FormKit>
        </div>
      </div>
    </FormKit>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import { optionsPositions } from '../configs';
import { translations } from '../../configs';

import { OptionWithString } from '@/types';
import { i18n } from '@/main';

@Options({
  name: 'AddOption',
  props: ['options', 'numberActiveOptions'],
  data() {
    return {
      formDataOption: {
        title: '',
        enabled: true,
        position: null,
        translations: {
          en: '',
          fi: '',
          sv: ''
        }
      },
      selectedPositions: {
        selectedOption: {},
        options: optionsPositions
      },
      error: '',
      translations,
      openAddOption: false
    };
  },
  methods: {
    conditionShowAddOption() {
      if (this.openAddOption && this.numberActiveOptions !== 3) {
        return true;
      }
    },
    showAddOption() {
      if (this.numberActiveOptions !== 3) {
        this.openAddOption = !this.openAddOption;
      }
    },
    selectPositions(selectedOption: OptionWithString) {
      const selectedPosition = parseInt(selectedOption.value);

      const disabledOption = Object.values(this.options).find(
        // eslint-disable-next-line
        (option: any) =>
          option.position === selectedPosition - 1 && !option.enabled
      );

      if (!disabledOption) {
        this.error = i18n.global.t('positionIsTaken');
        this.selectedPositions.selectedOption = {
          value: selectedPosition,
          label: selectedPosition
        };

        return;
      }

      this.selectedPositions.selectedOption = selectedOption;
      this.error = '';
      this.formDataOption.position = selectedPosition - 1;
    },
    submitForm() {
      this.$emit('submit-form-option', this.formDataOption);
    }
  }
})
export default class AddOption extends Vue {}
</script>

<style lang="scss">
.addOption {
  margin-bottom: 30px;
  .addOption__true {
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: max-content;
    cursor: pointer;
    img {
      margin-right: 10px;
    }
    .addOption__true-title {
      font-size: $fourteenSize;
      line-height: $fourteenSize;
      font-weight: 500;
      font-family: 'Ubuntu-Medium';
      color: $main-green;
    }
    &.tootip {
      position: relative;
      cursor: default;
      .tooltiptext {
        position: absolute;
        top: -30%;
        left: 52%;
        transform: translate(-50%, -100%);
        visibility: hidden;
        width: 138px;
        font-size: $elevenSize;
        line-height: $elevenSize;
        background: $label;
        color: $white;
        text-align: center;
        border-radius: 6px;
        padding: 5px;
        z-index: 1;
        opacity: 0;
        transition: opacity 0.3s;
        &::after {
          content: '';
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: $label transparent transparent transparent;
        }
      }

      &:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
      }
    }
  }
  .addOption__false {
    cursor: pointer;
    .addOption__false-title {
      font-size: $fourteenSize;
      line-height: $fourteenSize;
      font-weight: 500;
      font-family: 'Ubuntu-Medium';
      color: $red;
    }
  }
  #option-form {
    margin-top: 32px;
    .addOption__dropdown {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .title-options {
        font-size: 16px;
        margin-left: 100px;
        margin-right: 15px;
      }
      .dropdown-positions {
        width: 90px;
        height: 30px;
        &.dropdown-positions-error {
          .dropdown__head {
            border: 1px solid $red;
          }
        }
      }
      .error-message {
        color: $red;
        margin-left: 15px;
      }
    }
    .addOption__infoTemplates {
      display: flex;
      .input {
        width: 350px;
      }
      .addOption__infoTemplates-translations {
        margin-left: 100px;
        margin-bottom: 40px;
        width: 450px;
        .container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 30px;
          .input {
            display: inline-block;
            width: 350px;
            margin-left: 15px;
            margin-bottom: 0;

            .formkit-input {
              height: 48px;
            }
          }
        }
      }
    }
  }
}
</style>
